"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapCanBeSold = void 0;
var _internal = require("../utils/internal");
var _constants = require("./constants");
const mapCanBeSold = labels => labels?.find((0, _internal.findLabelByKey)(_constants.LABEL_ADD_TO_BASKET_VISIBLE)) !== undefined;
exports.mapCanBeSold = mapCanBeSold;
//# sourceMappingURL=mapCanBeSold.js.map